import React from 'react';
import PropTypes from 'prop-types';
import styles from './Sidebar.module.scss';

function SidebarHeader(props) {
  const IconComponent = props.icon;
  return (
    <div className={styles.sidebarHeader}>
      <h1>{ props.text }</h1>
      <div className={styles.headerIcon} onClick={props.onClickIcon}>
        <IconComponent size={20} />
      </div>

    </div>
  );
}

SidebarHeader.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.func.isRequired,
  onClickIcon: PropTypes.func
};

export default SidebarHeader;
